export const getCountryUsers = `
  query (
    $id: ID!,
  ) {
    country(id: $id){
      brandAmbassadors{
        nodes {
            recruitmentChannel
            recruitmentChannelOther
            recruitmentChannelSelectedAt
        }
      }
      recruitmentChannelsLog{
        selectedChannels
        createdAt
      }
    }
  }
`
